import axios from 'axios'
import { authService } from './authService'

// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',  // 改为相对路径，通过nginx代理
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 创建专门用于投诉建议的axios实例，设置更长的超时时间
const complaintApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 60000, // 60秒超时
  headers: {
    'Content-Type': 'application/json'
  }
})

// 调试信息
console.log('API Base URL:', api.defaults.baseURL)
console.log('Current location:', window.location.href)

// 请求拦截器
const requestInterceptor = (config) => {
  // 跳过登录请求的token检查
  if (config.url && config.url.includes('/auth/signin')) {
    return config
  }
  
  // 检查token是否已过期
  if (authService.isTokenExpired()) {
    localStorage.removeItem('user')
    window.location.href = '/'
    return Promise.reject(new Error('Token已过期'))
  }
  
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
}

api.interceptors.request.use(requestInterceptor, error => Promise.reject(error))
complaintApi.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

// 响应拦截器
const responseInterceptor = (response) => {
  // 如果是blob类型，直接返回（用于文件下载）
  if (response.config && response.config.responseType === 'blob') {
    return response
  }
  // 统一处理响应数据
  if (response.data && response.data.success !== undefined) {
    return response.data
  }
  return response
}

const errorInterceptor = (error) => {
  // 统一错误处理
  if (error.response) {
    const { status, data } = error.response
    
    switch (status) {
      case 401:
        // 检查是否是登录请求
        if (error.config && error.config.url && error.config.url.includes('/auth/signin')) {
          // 登录请求的401错误，不处理，让登录页面自己处理
          console.error('登录失败:', data?.message || '用户名或密码错误')
        } else {
          // 其他请求的401错误，清除用户信息并跳转到登录页
          localStorage.removeItem('user')
          // 显示友好的提示信息
          if (window.confirm('登录已过期，请重新登录')) {
            window.location.href = '/'
          } else {
            window.location.href = '/'
          }
        }
        break
      case 403:
        // 禁止访问
        console.error('访问被拒绝')
        break
      case 404:
        console.error('资源不存在')
        break
      case 500:
        console.error('服务器内部错误')
        break
      default:
        console.error('请求失败:', data?.message || error.message)
    }
  } else if (error.request) {
    console.error('网络错误，请检查网络连接')
  } else {
    console.error('请求配置错误:', error.message)
  }
  
  return Promise.reject(error)
}

api.interceptors.response.use(responseInterceptor, errorInterceptor)
complaintApi.interceptors.response.use(responseInterceptor, errorInterceptor)

export default api
export { complaintApi }

